<template>
  <nav class="bg-gray-800 shadow fixed w-full z-10">
    <div class="max-w-full">
      <div class="flex justify-between h-16">
        <!-- Left side -->
        <div class="flex items-center">
          <button v-if="!isMobile" @click="$emit('toggle-sidebar')" class="text-gray-300 hover:text-white p-2 ml-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div class="ml-1">
            <h1 class="text-xl font-bold text-white">Portfolio Manager</h1>
            <p class="text-sm text-gray-400">Gérez vos investissements</p>
          </div>
        </div>
        
        <!-- Right side -->
        <div v-if="isAuthenticated" class="flex-shrink-0 pr-2">
          <!-- Mobile : icône logout + email -->
          <div v-if="isMobile" class="flex items-center justify-center h-full space-x-2 mr-2">
            <span class="text-gray-300 text-xs truncate max-w-[80px]">{{ user?.email }}</span>
            <button @click="handleLogout" class="p-2 text-red-500 hover:text-red-700 focus:outline-none" title="Déconnexion">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h4a2 2 0 012 2v1" />
              </svg>
            </button>
          </div>
          <!-- Desktop : bouton classique + email -->
          <div v-else class="flex items-center justify-center space-x-4 mr-4 h-full">
            <span class="text-gray-300">{{ user?.email }}</span>
            <button
              @click="handleLogout"
              class="bg-red-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-red-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-red-500"
            >
              Déconnexion
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { defineComponent } from 'vue'
import { useAuthStore } from '../stores/auth'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'Navbar',
  emits: ['toggle-sidebar'],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const router = useRouter()
    const authStore = useAuthStore()
    const { isAuthenticated, user } = storeToRefs(authStore)

    const handleLogout = () => {
      authStore.logout()
      router.push('/login')
    }

    return {
      isAuthenticated,
      user,
      handleLogout
    }
  }
})
</script>

